import { render, staticRenderFns } from "./nudges.vue?vue&type=template&id=bd5bca1a&scoped=true&"
import script from "./nudges.vue?vue&type=script&lang=js&"
export * from "./nudges.vue?vue&type=script&lang=js&"
import style0 from "./nudges.vue?vue&type=style&index=0&id=bd5bca1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5bca1a",
  null
  
)

export default component.exports